import api from "@/services/api"

class ResourceService {

    getResourceList(lang = 'ge'){
        return api.get('/resource/' + lang)
    }

}

export default new ResourceService();